<button mat-button [matMenuTriggerFor]="languagePicker">
    {{languageService.getLanguage()}}
    <mat-icon>arrow_drop_down</mat-icon>
</button>
<mat-menu class="plr_language_menu" #languagePicker="matMenu" >
    <button mat-menu-item style="--mat-menu-item-hover-state-layer-color:{{getHoverColor()}}" *ngFor="let language of languages | async"
            (click)="onLanguageChanged(language.code)">
        {{language.code}}
    </button>
</mat-menu>
